import { Injectable } from '@angular/core';
import { PoolingPortalService } from '../services/pooling-portal.service';

@Injectable({
  providedIn: 'root'
})
export class FiltersService {
  shipList: any;

  constructor(private _poolingPortalService: PoolingPortalService) { 
  }
  
  public filterVessels(vessels:any,filters:any) {
    return  vessels.filter((item:any) => {
      const shipOwners: boolean = filters.shipOwners.reduce((prev:any, curr:string, currentIndex:number) => { 
        if (item.vslOwner && item.vslOwner.includes(curr)) {
          return true;
        }
        else if(currentIndex == 0) {
          return false;
        }
        else {
          return prev;
        }
      }, true);
      return shipOwners;
    });
  }

  /* public filterItemsDownload(allDistributionData:any,filters:any) {
    let distributionData =  this.filterItems(allDistributionData,filters);
    return  distributionData.filter((item:any) => {
     const vslNumber: boolean = filters.vslNumber.reduce((prev:any, curr:string, currentIndex:number) => { 
        if (item.vslNumber.includes(curr)) {
          return true;
        }
        else if(currentIndex == 0) {
          return false;
        }
        else {
          return prev;
        }
        }, true);
      return vslNumber;
    });
  } */

  public filterItems(allDistributionData:any,filters:any) {
    return  allDistributionData.filter((item:any) => {
      const ship: boolean = filters.ship.reduce((prev:any, curr:any, currentIndex:number) => { 
        if (item.vslName.includes(curr)) {
          return true;
        }
        else if(currentIndex == 0) {
          return false;
        }
        else {
          return prev;
        }
        }, true);
      const shipOwners: boolean = filters.shipOwners.reduce((prev:any, curr:any, currentIndex:number) => { 
        if (item.vslOwner.includes(curr)) {
          return true;
        }
        else if(currentIndex == 0) {
          return false;
        }
        else {
          return prev;
        }
      }, true);
      const subpool: boolean = filters.subpool.reduce((prev:any, curr:any, currentIndex:number) => { 
        if (item.subPool == curr) {
          return true;
        }
        else if(currentIndex == 0) {
          return false;
        }
        else {
          return prev;
        }
      }, true);
      const vslClass: boolean = (filters.vslClass || []).reduce((prev:any, curr:any, currentIndex:number) => {
        if (item.vslClass?.includes(curr)) {
          return true;
        }
        else if(currentIndex == 0) {
          return false;
        }
        else {
          return prev;
        }
      }, true);
      return ship && shipOwners && subpool && vslClass;
        
    });
    
  }

  public ships(vessels:any,filters:any) {
    let vessel =  vessels.filter((item:any) => {
      const shipOwners: boolean = filters.shipOwners.reduce((prev:any, curr:any, currentIndex:number) => { 
        if (item.vslOwner && item.vslOwner.includes(curr)) {
          return true;
        }
        else if(currentIndex == 0) {
          return false;
        }
        else {
          return prev;
        }
      }, true);
      const subpool: boolean = filters.subpool.reduce((prev:any, curr:any, currentIndex:number) => { 
        if (item.subPool && item.subPool == curr) {
          return true;
        }
        else if(currentIndex == 0) {
          return false;
        }
        else {
          return prev;
        }
      }, true);
      const vslClass: boolean = (filters.vslClass || []).reduce((prev:any, curr:any, currentIndex:number) => { 
        if (item.vslClass?.includes(curr)) {
          return true;
        }
        else if(currentIndex == 0) {
          return false;
        }
        else {
          return prev;
        }
      }, true);
      return shipOwners && subpool && vslClass;
    });
    let ships:any = [];
    vessel.map( (ele: any) => {
      let vslNameExist:any = ships.find((x:any) =>   x.value  === ele.vslName );
      if(ele.vslOwner != '' && ele.vslName &&  !vslNameExist){
        ships.push({ id : ele.vslName,name : ele.vslName});
      }
    });
    return ships.sort((a:any, b:any) => b.name < a.name ? 1 : -1);
  }

  public shipOwners(vessels:any,filters:any,ownersList:any = '') {
    console.log("filter vessel",vessels)
    console.log("filter filesssss",filters)
    let vessel =  vessels.filter((item:any) => {
      const ship: boolean = !filters.ship?.length || filters.ship.some((shipName: string) =>
      item.vslName?.toLowerCase().includes(shipName.toLowerCase()));
      const subpool: boolean =!filters.subpool?.length || filters.subpool.includes(item.subPool);
      const vslClass: boolean = !filters.vslClass?.length || filters.vslClass.some((cls: string) =>
      item.vslClass?.includes(cls));
      
      return ship && subpool && vslClass;
        
    });
    let shipOwners:any = [];
    vessel.map( (ele: any) => {
      let vslOwnerExist:any = shipOwners.find((x:any) =>   x.value  === ele.vslOwner );
      if(ele.vslOwner != '' && this._poolingPortalService.getVslOwnerLabel(ele.vslOwner,ownersList) &&  !vslOwnerExist){
        // shipOwners.push({ label : this._poolingPortalService.getVslOwnerLabel(ele.vslOwner,ownersList), value : ele.vslOwner});
        shipOwners.push({ id : ele.vslOwner,name : this._poolingPortalService.getVslOwnerLabel(ele.vslOwner,ownersList)});

      }
    });
    return shipOwners.sort((a:any, b:any) => a.name > b.name ? 1 : -1);
  }

  public subpools(vessels:any,filters:any) {
    let vessel =   vessels.filter((item:any) => {
       const ship: boolean = !filters.ship?.length || filters.ship.some((shipName: string) =>
      item.vslName?.toLowerCase().includes(shipName.toLowerCase()));
        const shipOwners: boolean = filters.shipOwners.reduce((prev:any, curr:string, currentIndex:number) => { 
        if (item.vslOwner && item.vslOwner.includes(curr)) {
          return true;
        }
        else if(currentIndex == 0) {
          return false;
        }
        else {
          return prev;
        }
      }, true);
      const vslClass: boolean = (filters.vslClass || []).reduce((prev:any, curr:string, currentIndex:number) => { 
        if (item.vslClass?.includes(curr)) {
          return true;
        }
        else if(currentIndex == 0) {
          return false;
        }
        else {
          return prev;
        }
      }, true);
      return ship && shipOwners && vslClass;
    });

    let subPoolAry:any = [];
    vessel.map( (ele: any) => {
      let vslSubPoolExist:any = subPoolAry.find((x:any) =>   x.value  === ele.subPool );
      if(ele.subPool && !subPoolAry.includes(ele.subPool) &&  !vslSubPoolExist){
        subPoolAry.push({ id : ele.subPool, name : ele.subPool});
      }
    });
    return subPoolAry.sort((a:any, b:any) => a.name > b.name ? 1 : -1);
  }

  public vslClass(vessels:any,filters:any) {
    let vessel =   vessels.filter((item:any) => {
       const ship: boolean = !filters.ship?.length || filters.ship.some((shipName: string) =>
      item.vslName?.toLowerCase().includes(shipName.toLowerCase()));
        const shipOwners: boolean = filters.shipOwners.reduce((prev:any, curr:string, currentIndex:number) => { 
        if (item.vslOwner && item.vslOwner.includes(curr)) {
          return true;
        }
        else if(currentIndex == 0) {
          return false;
        }
        else {
          return prev;
        }
      }, true);
      const subpool: boolean = filters.subpool.reduce((prev:any, curr:string, currentIndex:number) => { 
        if (item.subPool && item.subPool == curr) {
          return true;
        }
        else if(currentIndex == 0) {
          return false;
        }
        else {
          return prev;
        }
      }, true);
      return ship && shipOwners && subpool;
    });

    let vslClass:any = [];
    vessel.map( (ele: any) => {
      let vslClassExist:any = vslClass.find((x:any) =>   x.value  === ele.vslClass );
      if(ele.vslClass != '' && ele.vslClass &&  !vslClass.includes(ele.vslClass) &&  !vslClassExist){
        vslClass.push({ id : ele.vslClass, name : ele.vslClass});
      }
    });
    return vslClass.sort((a:any, b:any) => a.name > b.name ? 1 : -1);
  }

  /* public status(vessels:any,filters:any) {
    let vessel =   vessels.filter((item:any) => {
      const ship: boolean = !filters.ship?.length || filters.ship.some((shipName: string) =>
      item.vslName?.toLowerCase().includes(shipName.toLowerCase()));
        const shipOwners: boolean = filters.shipOwners.reduce((prev:any, curr:string, currentIndex:number) => { 
        if (item.vslOwner && item.vslOwner.includes(curr)) {
          return true;
        }
        else if(currentIndex == 0) {
          return false;
        }
        else {
          return prev;
        }
      }, true);
      const subpool: boolean = filters.subpool.reduce((prev:any, curr:string, currentIndex:number) => { 
        if (item.subPool && item.subPool == curr) {
          return true;
        }
        else if(currentIndex == 0) {
          return false;
        }
        else {
          return prev;
        }
      }, true);
      return ship && shipOwners && subpool;
    });

    let vslSatus:any = [];
    let statusExist = vessel.map( (ele: any) => ele.iActive);
    statusExist = [...new Set(statusExist)];
    vslSatus = statusExist.map((e:any)=>{
      return (e)?{ 'label': 'Active', 'value': '1' }:{ 'label': 'Inactive', value: '0' }
    })
    return vslSatus.sort((a:any, b:any) => a.label > b.label ? 1 : -1);
  } */

  public stjsfilter(data:any,filters:any) {
    return  data.filter((item:any) => {
      let shipOwners: boolean = this.shipOwnersFilters(filters,item);
      let status: boolean = this.statusFilters(filters,item);
      let vslClass: boolean = this.vslClassFilters(filters,item);
      let vslName: boolean = this.vslNameFilters(filters,item);
      let subpool: boolean = this.subpoolFilters(filters,item);
      return shipOwners && status && vslClass && vslName && subpool;
    });
  }

  public vslClassFilters(filters,item){
    return filters.vslClass.reduce((prev:any, curr:string, currentIndex:number) => { 
      if (item?.vslClass?.includes(curr)) {
        return true;
      }
      else if(currentIndex == 0) {
        return false;
      }
      else {
        return prev;
      }
    }, true)
  }

  public vslNameFilters(filters,item){
    return filters.ship.reduce((prev:any, curr:string, currentIndex:number) => {
      if (item?.vslName?.toLowerCase().includes(curr.toLowerCase())) {
        return true;
      }
      else if(currentIndex == 0) {
        return false;
      }
      else {
        return prev;
      }
    }, true);
  }

  public subpoolFilters(filters,item){
    return filters.subpool.reduce((prev:any, curr:any, currentIndex:number) => { 
      if (item?.subPool == curr) {
        return true;
      }
      else if(currentIndex == 0) {
        return false;
      }
      else {
        return prev;
      }
    }, true);
  }

  public statusFilters(filters,item){
    return filters.status.reduce((prev:any, curr:string, currentIndex:number) => { 
      if (item.iActive == curr) {
        return true;
      }
      else if(currentIndex == 0) {
        return false;
      }
      else {
        return prev;
      }
    }, true);
  }

  public shipOwnersFilters(filters,item){
    return filters.shipOwners.reduce((prev:any, curr:string, currentIndex:number) => { 
      if (item?.vslOwner?.includes(curr)) {
        return true;
      }
      else if(currentIndex == 0) {
        return false;
      }
      else {
        return prev;
      }
    }, true);
  }

  public stjsfilterItemsDownload(data:any,filters:any) {
    let filterData =  this.stjsfilter(data,filters);
    return  filterData.filter((item:any) => {
     const vslNumber: boolean = filters.vslNumber.reduce((prev:any, curr:string, currentIndex:number) => { 
        if (item.vslNumber.includes(curr)) {
          return true;
        }
        else if(currentIndex == 0) {
          return false;
        }
        else {
          return prev;
        }
        }, true);
      return vslNumber;
    });
  }

}